import { render } from "./TagManagementPage.vue?vue&type=template&id=0717fb36&scoped=true"
import script from "./TagManagementPage.vue?vue&type=script&lang=js"
export * from "./TagManagementPage.vue?vue&type=script&lang=js"

import "./TagManagementPage.vue?vue&type=style&index=0&id=0717fb36&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0717fb36"]])

export default __exports__